import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-style-guide';
import { DeviceMeta } from 'Roblox';
import GetPremiumButton from './GetPremiumButton';

const { isInApp } = DeviceMeta();

function TitleAnchor({ translate, isShown }) {
  const getAnchorStyle = useCallback(() => {
    if (isShown) {
      return isInApp ? 'anchor-show-mobile' : 'anchor-show-desktop';
    }
    return 'anchor-hide';
  }, [isShown]);

  return (
    <div className={getAnchorStyle()}>
      <div className='title-anchor-container layer'>
        <div className='font-header-2 title-anchor-label'>{translate('Heading.RobloxPremium')}</div>
        <GetPremiumButton translate={translate} size={Button.sizes.medium} />
      </div>
    </div>
  );
}

TitleAnchor.propTypes = {
  translate: PropTypes.func.isRequired,
  isShown: PropTypes.bool.isRequired
};

export default TitleAnchor;
